export const SIZE = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;

export const SKIN = {
  standard: 'standard',
  error: 'error',
  warning: 'warning',
  dark: 'dark',
  neutral: 'neutral',
  success: 'success',
  light: 'light',
  lightOutlined: 'lightOutlined',
} as const;

export const dataHooks = {
  removeButton: 'tag-remove-button',
  text: 'tag-text',
  thumb: 'tag-thumb',
} as const;

export const dataAttr = {
  SIZE: 'data-size',
  DISABLED: 'data-disabled',
  SKIN: 'data-skin',
  HOVERABLE: 'data-hoverable',
  CLICKABLE: 'data-clickable',
} as const;

export const tagToTextSize = {
  tiny: 'tiny',
  small: 'tiny',
  medium: 'small',
  large: 'small',
} as const;

export const tagToTextWeight = {
  tiny: 'bold',
  small: 'bold',
  medium: 'normal',
  large: 'normal',
} as const;

export const validRemoveKeys = ['Enter', ' '] as const;
